import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import { useAccessUser } from '@hook/useAccessUser'
import { useFormik } from 'formik'

import { TextInput } from '@components/shared/TextInput'
import TextArea from '@components/shared/TextArea'
import CustomModal from '@/components/shared/CustomModal/CustomModal'

/* type AddProjectProps = {
    showAdd: boolean
    showHideAdd: (showAdd: boolean) => void
    isUpdateList: boolean
    setUpdateList: (isUpdateList: boolean) => void
    editProject?: Project
} */

export const AddProject = ({
    showAdd,
    showHideAdd,
    editProject,
    isUpdateList,
    setUpdateList,
}) => {
    
    const recentProjects = useWireValue(store.recentProjects)
    
    const formik = useFormik({
        initialValues: { name: editProject?.name || '', description: editProject?.description || '' },
        
        onSubmit: values => {
            if (!editProject?.id) {
                actions.createProject(values)
            } else {
                actions.updateProject({ ...editProject, name: values.name, description: values.description })
                recentProjects &&
                    recentProjects.forEach(proj => {
                        if (proj.projectId === editProject.id) {
                            actions.updateRecentProject({
                                userId: proj.userId,
                                projectName: values.name,
                                projectId: proj.projectId,
                            })
                        }
                    })
            }
            
            showHideAdd(!showAdd)
            setUpdateList(!isUpdateList)
        },
    })
    
    const editProjectName = useAccessUser({
        accessType: 'projects',
        accessName: 'edit_project_name',
    })
    
    const { handleSubmit, handleChange, values } = formik
    
    return (
        <CustomModal className="AddProduct-modal" open={showAdd} modalHandler={() => showHideAdd(!showAdd)} center>
            <form onSubmit={handleSubmit}>
                <div className="modal-header">
                    <h2 className="modal-title">{`${(editProject?.id && 'Edit') || 'Add'} Project`}</h2>
                </div>
                <div
                    className="modal-body"
                    style={{
                        maxHeight: '500px',
                        overflow: 'auto',
                    }}>
                    <TextInput
                        name="name"
                        className="px-0 col"
                        value={values.name}
                        handleChange={handleChange}
                        label="Name"
                        placeholder=""
                        disabled={!editProjectName} />
                    <div className="mt-3 form-group">
                        <label htmlFor="inputDescription">Description</label>
                        <TextArea id="inputDescription" name="description" className="form-control" rows={7} />
                    </div>
                </div>
                <div className="modal-footer flex justify-between">
                    <button
                        type="button"
                        className="btn btn-primary btn-lg btn-outline"
                        onClick={() => showHideAdd(!showAdd)}>
                        Cancel
                    </button>
                    <button type="submit" className="ml-auto AddProject-submit-button btn btn-primary btn-lg">
                        {`${(editProject?.id && 'Edit') || 'Create'}`}
                    </button>
                </div>
            </form>
        </CustomModal>
    )
}
